import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { Block } from "./Common";

const when = (iso) =>
  new Date(iso).toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });

export default function PanelAudit({ version }) {
  const [rows, setRows] = useState([]);
  const [all, setAll] = useState(false);
  const load = useCallback(async () => {
    try {
      const r = await api.get("/audit", { params: { limit: all ? 300 : 30 } });
      setRows(r.data);
    } catch {
      setRows([]);
    }
  }, [all]);
  useEffect(() => { load(); }, [load, version]);

  return (
    <Block title="Log aktivitas panel" testid="panel-audit">
      <div className="mb-3 flex items-center justify-between gap-2">
        <p className="text-xs text-[#7a6667]">Siapa mengubah pengaturan, mereset PIN, mengelola anggota, atau memulihkan backup.</p>
        <button data-testid="audit-refresh" onClick={load} aria-label="Muat ulang" className="btn-ghost h-11 w-11 shrink-0 p-0"><RefreshCw size={15} /></button>
      </div>
      <div data-testid="audit-list" className="divide-y divide-brand-line rounded-xl border border-brand-line">
        {rows.length === 0 && <p className="p-3 text-sm text-[#7a6667]">Belum ada aktivitas tercatat.</p>}
        {rows.map((r, i) => (
          <div key={`${r.at}-${i}`} data-testid={`audit-row-${i}`} className="p-3 text-sm">
            <div className="flex flex-wrap items-baseline justify-between gap-x-3">
              <span className="font-bold">{r.action}</span>
              <span className="text-xs text-[#7a6667]">{when(r.at)} WIB</span>
            </div>
            <div className="text-xs font-semibold text-brand-deep">oleh {r.actor}</div>
            {r.detail && <div className="mt-0.5 break-words text-xs text-[#4a3d3e]">{r.detail}</div>}
          </div>
        ))}
      </div>
      {rows.length >= 30 && !all && (
        <button data-testid="audit-show-all" onClick={() => setAll(true)} className="btn-ghost mt-3">Tampilkan lebih banyak</button>
      )}
    </Block>
  );
}
